import { Button, cn, Icon, Typography } from "@kyan/ui";
import Link from "next/link";

import { Divider } from "#/components/Divider/Divider";
import { InstrumentTag } from "#/components/InstrumentTag/InstrumentTag";
import { createOptionInstrumentName } from "#/utils/instrument.utils";
import { isBuy } from "#/utils/marketActionConverter";

import { PerpWithCancel } from "../../../PerpsTab/components/PerpSummary/components/PerpWithCancel/PerpWithCancel";
import { useComboContentController } from "./ComboContent.controller";

export const ComboContent: React.FC = () => {
  const {
    market,
    routes,
    isComboRFQ,
    isOnComboPage,
    isOnOptionsPage,
    comboPerpInstrument,
    disablePerpButton,
    disableNewLegsButton,
    isInAddingNewLegState,
    comboOptionInstruments,
    comboActiveInstrumentId,
    maxComboOptionInstruments,
    handleAddLeg,
    handleDelete,
    handleAddPerp,
    handleSelectInstrument,
  } = useComboContentController();

  return (
    <>
      {comboOptionInstruments.map((item) => (
        <InstrumentTag
          price={2500}
          key={item.id}
          isBuy={isBuy(item.side)}
          instrumentName={createOptionInstrumentName(item)}
          isActive={isOnOptionsPage && item.id === comboActiveInstrumentId}
          onRemove={() => {
            handleDelete(item.id);
          }}
          onClick={
            isOnOptionsPage
              ? () => {
                  handleSelectInstrument(item);
                }
              : undefined
          }
        />
      ))}

      {!isOnComboPage && (
        <Button
          variant="secondary"
          disabled={disableNewLegsButton}
          className={cn("w-full justify-between", {
            "border border-[#FFF45B]": isInAddingNewLegState,
          })}
          onClick={handleAddLeg}
        >
          {isInAddingNewLegState ? (
            <>
              <Typography>+ Adding new legs from order book</Typography>
              <Icon size="xs" name="cross" />
            </>
          ) : (
            `Updating selected leg (${comboOptionInstruments.length}/${maxComboOptionInstruments})`
          )}
        </Button>
      )}

      {!isOnComboPage && (
        <>
          {comboPerpInstrument ? (
            <PerpWithCancel
              disabled={isComboRFQ}
              underlying={comboPerpInstrument.underlying}
              onRemove={() => {
                handleDelete(comboPerpInstrument.id);
              }}
            />
          ) : (
            <Button
              className="w-full"
              variant="secondary"
              disabled={disablePerpButton}
              onClick={handleAddPerp}
            >
              + Add {market.underlying} Perp
            </Button>
          )}
        </>
      )}

      {!isOnComboPage && (
        <>
          <Divider />
          <Typography grotesk size={12} className="text-center">
            To finish the trade, continue on the combo page
          </Typography>
          <Link href={routes.combo}>
            <Button size="lg" className="w-full shadow-none">
              Open Combo page
            </Button>
          </Link>
        </>
      )}
    </>
  );
};
